import { Box, Button, Divider, Flex, FormControl, FormLabel, HStack, IconButton, Input, Select, Stack, Text, Textarea, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { Link as DefaultLink, useNavigate } from 'react-router-dom';
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import React, { useCallback, useEffect, useState } from 'react';
import { addDelivery, fetchCustomers, fetchDeliveries } from '../../store/actions';
import { companyCustomerType, deliveryType, fleetType } from '../../types';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { DistanceMatrixService } from '@react-google-maps/api';
import { FiArrowLeft } from 'react-icons/fi';
import { ToastContainer } from 'react-toastify';
import { addDeliveryFormValidation } from '../../utils';
import { fetchFleets } from '../../store/actions/fleet-actions';
import moment from 'moment';
import { useFormik } from 'formik';

export const AddDelivery = () => {

    const [customer, setCustomer] = useState<any>({});
    const [fleet, setFleet] = useState<any>({});

    const [_loaders] = useState<Array<number>>([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);

    const DRIVING: any = 'DRIVING';

    const [origin, setOrigin] = useState<any | null>(null);
    const [originCoords, setOriginCoords] = useState<any | null>(null);

    const [destination, setDestination] = useState<any | null>(null);
    const [desCoords, setDesCoords] = useState<any | null>(null);

    const [distance, setDistance] = useState<string | any>('0 km');

    const { fleets } = useAppSelector(state => state.fleetReducer);

    const { customers } = useAppSelector(state => state.customersReducer);

    const { is_adding_delivery } = useAppSelector(state => state.deliveryReducer);

    const { company } = useAppSelector(state => state.companyReducer);

    const { google_api_key, settings } = company ?? {};
    const { payment } = settings ?? {};
    const { vat } = payment;

    const dispatch: AppDispatch = useAppDispatch();

    const navigate = useNavigate();

    const deliveryForm = useFormik({
        initialValues: {
            customer_id: '',
            date: '',
            fleet: '',
            payment_method: '',
            loaders: '',
            loaders_amount: '',
            total: '',
            description: '',
        },
        validationSchema: addDeliveryFormValidation,
        onSubmit: (values: deliveryType) => {

            const _customer = {
                customer_id: customer?.customer_id,
                customer_name: `${customer?.first_name} ${customer?.last_name}`,
            };

            const from = {
                address_from: origin?.label,
                from_lat: originCoords?.lat,
                from_long: originCoords?.long
            };

            const to = {
                address_to: destination?.label,
                to_lat: desCoords?.lat,
                to_long: desCoords?.long
            };

            const time = moment(values?.date).format('HH:mm');
            const newValues: any = { ...values, from, to, time, ..._customer, loaders_amount, total, status: 'await approval', distance: Number(distance?.split(' ')[0]), distance_amount: fleet?.per_km * Number(distance.split(' ')[0]), vat: vat ? (sub_total * 0.15).toFixed(2) : 0, fleet_amount: fleet?.fleet_amount };
            dispatch(addDelivery(newValues)).then(() => navigate('/deliveries'));
            // alert(JSON.stringify(newValues, null, 2));
        }
    });

    const loaders_amount = (Number(deliveryForm.values.loaders) * fleet?.loader_amount) || 0;
    const sub_total = (fleet?.fleet_amount) + (fleet?.per_km * Number(distance?.split(' ')[0])) + (Number(deliveryForm.values.loaders) * fleet?.loader_amount);
    const total = (sub_total + (vat ? (sub_total * 0.15) : 0)) || 0;

    const getOriginCoords = useCallback(() => {
        origin && geocodeByAddress(origin?.label)
            .then((results: Array<any>) => getLatLng(results[0]))
            .then(({ lat, lng }: any) => {
                setOriginCoords({ lat: lat, long: lng });
            }
            );


    }, [origin]);

    const getDesCoords = useCallback(() => {
        destination && geocodeByAddress(destination?.label)
            .then((results: Array<any>) => getLatLng(results[0]))
            .then(({ lat, lng }: any) => {
                setDesCoords({ lat: lat, long: lng });
            }
            );
    }, [destination]);

    useEffect(() => {
        const selectedFleet = fleets?.filter((fleet: fleetType) => fleet.fleet_size === deliveryForm.values.fleet)[0];
        setFleet(selectedFleet);
    }, [deliveryForm.values.fleet]);

    useEffect(() => {
        const selectedCustomer = customers?.filter((customer: companyCustomerType) => customer.customer_id === deliveryForm.values.customer_id)[0];
        setCustomer(selectedCustomer);
    }, [deliveryForm.values.customer_id]);

    useEffect(() => {
        getOriginCoords();
        getDesCoords();
    }, [origin, destination]);


    useEffect(() => {
        dispatch(fetchDeliveries());
        dispatch(fetchFleets());
        dispatch(fetchCustomers());
    }, []);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            {origin && destination && <DistanceMatrixService
                options={{
                    destinations: [{ lat: desCoords?.lat, lng: desCoords?.long }],
                    origins: [{ lng: originCoords?.long, lat: originCoords?.lat }],
                    travelMode: DRIVING
                }}
                callback={(response) => {
                    // console.log(response?.rows[0]?.elements[0]?.distance?.text);
                    const _distance: any = response?.rows[0]?.elements[0]?.distance?.text;
                    setDistance(_distance);
                }}
            />}
            <Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                        <HStack align={'center'}>
                            <Stack>
                                <IconButton variant={'ghost'} aria-label='go back' icon={<FiArrowLeft style={{ width: '24px', height: '24px' }} />} as={DefaultLink} to='/deliveries' />
                            </Stack>
                            <Stack>
                                <Text display={'flex'} fontSize={'lg'} fontWeight='medium' textAlign={'center'}>
                                    Add new delivery.
                                </Text>
                            </Stack>
                        </HStack>
                        <Divider />
                        <Stack mb={3}>
                            <Text textAlign={'center'} fontSize={'lg'} color={'gray.600'}>
                                To enjoy all of our cool features ✌️
                            </Text>
                        </Stack>
                        <form onSubmit={deliveryForm.handleSubmit}>
                            <FormControl id="customer" isRequired mb={deliveryForm.errors.customer_name ? 0 : 5}>
                                <HStack justifyContent={'space-between'}>
                                    <FormLabel>Customer</FormLabel>
                                    <Tooltip label='Add customer' fontSize='md'>
                                        <Button size={'xs'} colorScheme={'yellow'} fontWeight={'bold'} onClick={() => navigate('/customers/add')}>+</Button>
                                    </Tooltip>
                                </HStack>
                                <Select style={{ textTransform: 'capitalize' }} name='customer_id' value={deliveryForm.values.customer_id} onChange={deliveryForm.handleChange} placeholder='Select customer'>
                                    {
                                        customers && customers.map((customer: companyCustomerType, index: number) => (
                                            <option key={index} style={{ textTransform: 'capitalize' }} value={`${customer.customer_id}`} >{customer.first_name} {customer.last_name}</option>
                                        ))
                                    }
                                </Select>
                                {!customer && <Text fontSize='sm' color='red.400'>Select a customer</Text>}
                            </FormControl>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="date" isRequired mb={deliveryForm.errors.date ? 0 : 5}>
                                        <FormLabel>Date and Time</FormLabel>
                                        <Input name='date' type="datetime-local" value={deliveryForm.values.date} onChange={deliveryForm.handleChange} />
                                        {deliveryForm.errors.date && <Text fontSize='sm' color='red.400'>{deliveryForm.errors.date}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="fleet" isRequired mb={deliveryForm.errors.fleet ? 0 : 5}>
                                        <HStack justifyContent={'space-between'}>
                                            <FormLabel>Fleet size</FormLabel>
                                            <Tooltip label='Add fleet' fontSize='md'>
                                                <Button size={'xs'} colorScheme={'yellow'} fontWeight={'bold'} onClick={() => navigate('/vehicles/fleets/add')}>+</Button>
                                            </Tooltip>
                                        </HStack>
                                        <Select name='fleet' placeholder='Select fleet' value={deliveryForm.values.fleet} onChange={deliveryForm.handleChange}>
                                            {
                                                fleets && fleets.map((fleet: fleetType, index: number) => (
                                                    <option key={index} value={`${fleet.fleet_size}`}>{fleet.fleet_size}</option>
                                                ))
                                            }
                                        </Select>
                                        {deliveryForm.errors.fleet && <Text fontSize='sm' color='red.400'>{deliveryForm.errors.fleet}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="payment_method" isRequired mb={deliveryForm.errors.payment_method ? 0 : 5}>
                                        <FormLabel>Payment method</FormLabel>
                                        <Select name='payment_method' placeholder='Select method' value={deliveryForm.values.payment_method} onChange={deliveryForm.handleChange}>
                                            <option value='cash'>Cash</option>
                                            <option value='card'>Card</option>
                                            <option value='eft'>EFT</option>
                                        </Select>
                                        {deliveryForm.errors.payment_method && <Text fontSize='sm' color='red.400'>{deliveryForm.errors.payment_method}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="loaders" isRequired mb={deliveryForm.errors.payment_method ? 0 : 5}>
                                        <FormLabel>Number of loaders</FormLabel>
                                        <Select name='loaders' placeholder='Select loaders' value={deliveryForm.values.loaders} onChange={deliveryForm.handleChange} disabled={!fleet}>
                                            {
                                                _loaders?.map((loader: number, index: number) => <option key={index} value={loader}>{loader} - R{loader * fleet?.loader_amount}</option>)
                                            }
                                        </Select>
                                        {deliveryForm.errors.payment_method && <Text fontSize='sm' color='red.400'>{deliveryForm.errors.payment_method}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <FormControl id="address" isRequired mb={origin ? 3 : 5}>
                                <FormLabel>Pick-up address</FormLabel>
                                <GooglePlacesAutocomplete
                                    apiKey={google_api_key}
                                    apiOptions={{ region: 'za' }}
                                    selectProps={{
                                        placeholder: 'Pick up',
                                        origin,
                                        onChange: setOrigin
                                    }}
                                />
                                {/* <Input name='address' type="text" value={companyForm.values.address} onChange={companyForm.handleChange} /> */}
                                {!origin && !originCoords && <Text fontSize='sm' color='red.400'>{'Enter your address'}</Text>}
                            </FormControl>
                            <FormControl id="address" isRequired mb={destination ? 3 : 5}>
                                <FormLabel>Drop-off address</FormLabel>
                                <GooglePlacesAutocomplete
                                    apiKey={google_api_key}
                                    apiOptions={{ region: 'za' }}
                                    selectProps={{
                                        placeholder: 'Drop off',
                                        destination,
                                        onChange: setDestination
                                    }}
                                />
                                {/* <Input name='address' type="text" value={companyForm.values.address} onChange={companyForm.handleChange} /> */}
                                {!destination && !desCoords && <Text fontSize='sm' color='red.400'>{'Enter your address'}</Text>}
                            </FormControl>
                            <FormControl mb={3}>
                                <FormLabel>Description</FormLabel>
                                <Textarea name='description' value={deliveryForm.values.description} onChange={deliveryForm.handleChange} />
                                {deliveryForm.errors.description && <Text color={'red.500'} fontSize={'sm'}>{deliveryForm.errors.description}</Text>}
                            </FormControl>
                            <Stack bg={'#f5f5f5'} p={3} borderRadius={6} mb={3}>
                                <Text>Fleet Amount: {`R ${fleet?.fleet_amount || 0}`}</Text>
                                <Text>Distance: {distance} * R{fleet?.per_km || 0} = {`R ${(fleet?.per_km * Number(distance.split(' ')[0])).toFixed(2) || 0}`}</Text>
                                <Text style={{ marginTop: '0rem !important' }}>Loaders: {deliveryForm.values.loaders || 0} x R{fleet?.loader_amount || 0} =  R{(Number(deliveryForm.values.loaders) * fleet?.loader_amount) || 0}</Text>
                                <p>Vat (15%): R{(vat ? (sub_total * 0.15).toFixed(2) : 0) || 0}</p>
                                <Text fontWeight={'bold'}>Total: R{(total).toFixed(2)}</Text>
                            </Stack>
                            <Stack spacing={10} pt={2}>
                                <Button
                                    type='submit'
                                    isLoading={is_adding_delivery}
                                    disabled={!customer || !origin || !originCoords || !desCoords || !destination || is_adding_delivery}
                                    loadingText="Submitting"
                                    size="lg"
                                    colorScheme={'yellow'}
                                >
                                    Submit
                                </Button>
                            </Stack>
                        </form>
                    </Stack>
                </Box>
            </Stack>
            <ToastContainer />
        </Flex>
    );
};